import { createDraftSafeSelector } from '@reduxjs/toolkit';
import { RootState } from 'modules/index';

const baseAppState = (state: RootState) => state.app;

const selectSnackBarState = createDraftSafeSelector(baseAppState, (state) => state.snackbar);

export default { selectSnackBarState };
